import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export default function Register() {
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [orgName, setOrgName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!fullName.trim() || !orgName.trim() || !email.trim() || !password.trim()) {
      toast.error("Please fill in all fields.");
      return;
    }

    setLoading(true);
    try {
      // Sign up in Supabase Auth, passing metadata to trigger profile sync
      const { error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            full_name: fullName,
            org_name: orgName,
          },
        },
      });

      if (error) throw error;

      toast.success("Account created successfully! Redirecting to login...");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      toast.error(err.message || "Registration failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-canvas flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="text-center text-xs font-medium uppercase tracking-wider text-soft mb-2">
          RECRUIT.IQ — SIGN UP
        </h2>
        <h1 className="text-center text-4xl sm:text-5xl font-serif font-light text-ink tracking-tight">
          Create Organization
        </h1>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md px-4 sm:px-0">
        <div className="bg-white py-8 px-4 border hairline sm:px-10 rounded-2xl shadow-lift">
          <form className="space-y-6" onSubmit={handleRegister}>
            <div>
              <label className="block text-xs font-medium uppercase tracking-wider text-sub">
                Full Name
              </label>
              <input
                type="text"
                required
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                className="mt-1 block w-full input-apple"
                placeholder="e.g. Sarah Jenkins"
              />
            </div>

            <div>
              <label className="block text-xs font-medium uppercase tracking-wider text-sub">
                Organization / Company Name
              </label>
              <input
                type="text"
                required
                value={orgName}
                onChange={(e) => setOrgName(e.target.value)}
                className="mt-1 block w-full input-apple"
                placeholder="e.g. Acme Tech Labs"
              />
            </div>

            <div>
              <label className="block text-xs font-medium uppercase tracking-wider text-sub">
                Email Address
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 block w-full input-apple"
                placeholder="sarah@company.com"
              />
            </div>

            <div>
              <label className="block text-xs font-medium uppercase tracking-wider text-sub">
                Password
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 block w-full input-apple"
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full btn-primary flex items-center justify-center py-3 px-6 disabled:opacity-50"
              >
                {loading ? "Creating..." : "Sign Up"}
                <ArrowRight className="ml-2 h-4 w-4" />
              </button>
            </div>
          </form>

          <div className="mt-6 text-center">
            <p className="text-xs font-sans text-sub">
              Already have an account?{" "}
              <Link
                to="/login"
                className="font-medium text-xs text-accent hover:underline"
              >
                Sign In
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
